import { filter, includes } from 'lodash-es';

// Custom collection helpers (originally `_.mixin(...)` in gizmoGrid.js / Dashboard.ts).
// Re-implemented as standalone named exports so webpack/ESM tree-shaking and
// TypeScript both see them, and so we don't depend on mutating the lodash-es
// namespace at module load time (`_.mixin` is unsafe with namespace imports).

export function findByValues<T = any>(
  collection: T[] | null | undefined,
  property: string,
  values: any[]
): T[] {
  return filter(collection ?? [], (item: any) => includes(values, item[property]));
}

export function findByValuesNot<T = any>(
  collection: T[] | null | undefined,
  property: string,
  values: any[]
): T[] {
  return filter(collection ?? [], (item: any) => !includes(values, item[property]));
}

export function findByKeyPartialValue<T = any>(
  collection: T[] | null | undefined,
  value: string,
  predicate: string
): T[] {
  return filter(collection ?? [], (object: any) => {
    const n = object[predicate];
    if (n != undefined) {
      return includes(n.toString().toLowerCase(), value.toLowerCase());
    }
    return false;
  });
}

export function findNotByKeyPartialValue<T = any>(
  collection: T[] | null | undefined,
  value: string,
  predicate: string
): T[] {
  return filter(collection ?? [], (object: any) => {
    const n = object[predicate];
    if (n != undefined) {
      return !includes(n.toString().toLowerCase(), value.toLowerCase());
    }
    return false;
  });
}

export function findNumByProperty<T = any>(
  collection: T[] | null | undefined,
  property: string,
  value: any,
  operator: string
): T[] {
  return filter(collection ?? [], (object: any) => {
    const num = parseFloat(object[property]);
    if (operator === '>=' && num >= value) return true;
    if (operator === '<=' && num <= value) return true;
    if (operator === '=' && num == value) return true;
    if (operator === '!=' && num != value) return true;
    if (operator === '>' && num > value) return true;
    if (operator === '<' && num < value) return true;
    return false;
  });
}
